/**
 * notificationGrouping.js — saf (React/react-router-dom bağımlılığı OLMAYAN)
 * filtre + bucket gruplama mantığı.
 *
 * Bilinçli olarak NotificationFeed.jsx'ten AYRI bir modülde tutulur: bu
 * ortamda `react-router-dom` (v7, ESM-only) mevcut Jest/react-scripts CJS
 * resolver'ı ile test sırasında import edilemiyor (bkz. proje geneli
 * mevcut altyapı kısıtı — final raporda ayrıca not edildi). Saf mantığı
 * burada izole tutmak, NotificationFeed.jsx'in kendi React/router
 * bağımlılıklarını değiştirmeden birim testi yazılabilmesini sağlar.
 */

// Backend `_bucket_for()` sadece today/week/older döner; "this_week" eski
// (admin tarafından elle yazılmış) kayıtlar için geriye dönük uyumluluk.
export const BUCKET_ORDER = ['today', 'this_week', 'week', 'older'];

/**
 * Bildirim listesini bucket'lara göre gruplar, sıralı array döner.
 */
export function groupByBucket(list) {
  const grouped = {};
  (list || []).forEach((n) => {
    const b = n.bucket || 'older';
    if (!grouped[b]) grouped[b] = [];
    grouped[b].push(n);
  });
  return BUCKET_ORDER.filter((b) => grouped[b]?.length > 0).map((b) => ({
    bucket: b,
    items: grouped[b],
  }));
}

/**
 * "all" / "unread" istemci-taraflı filtresi.
 */
export function filterNotifications(list, filter) {
  const safeList = list || [];
  if (filter === 'unread') return safeList.filter((n) => !n.is_read);
  return safeList;
}
